/* eslint-disable no-undef */
const strings = window.enervent.translations;

export { strings }; // eslint-disable-line import/prefer-default-export
